// Vendor libraries
import { ChangeDetectorRef, EventEmitter, } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils / constants
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { EDIT_PDF_REPORT_BUILDER_FEATURE, GENERATE_PDF_REPORT_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { LEGACY_REPORT_TYPES } from 'CustomPDFReportsApp/ts/constants';
// Interfaces / enums / types
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
// Components
import { FolderableBase } from 'FoldersApp/directives/folderable-base.directive';
// Services
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// NgRx Actions
import { addSelectedReportWizardStep, resetSelectedReport, setSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { getSelectedReport } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { isCustomPDFReport } from 'CustomPDFReportsApp/ts/utils/custom-pdf-report-utils';
import { setGenerateModalSelectedFolderableOperation } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate-modal-selected-folderable-operation/generate-modal-selected-folderable-operation.action';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "SharingApp/ts/services/sharing.service";
import * as i5 from "@angular/common";
import * as i6 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i7 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i10 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
import * as i11 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i12 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = () => ({ visibility: "hidden" });
const _c1 = a0 => ({ visibility: a0 });
const _c2 = () => ["popover"];
function GenerateModalFolderableListItemComponent_Conditional_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    i0.ɵɵproperty("textContent", folder_r1.name);
} }
function GenerateModalFolderableListItemComponent_Conditional_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelement(4, "div", 8);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 10);
    i0.ɵɵelementStart(7, "div", 11)(8, "label", 12);
    i0.ɵɵelement(9, "input", 13)(10, "span", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folder_r2 = ctx.folder;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 3, folder_r2.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 6, folder_r2));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(8, _c0));
} }
function GenerateModalFolderableListItemComponent_Conditional_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-generate-modal-folderable-list-item", 15);
    i0.ɵɵlistener("errorHandler", function GenerateModalFolderableListItemComponent_Conditional_0_ng_template_5_Template_ycn_generate_modal_folderable_list_item_errorHandler_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.errorHandler.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folderable_r5 = ctx.folderable;
    const ancestorInfo_r6 = ctx.ancestorInfo;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("folderable", folderable_r5)("ancestorInfo", ancestorInfo_r6)("baseResourceType", ctx_r3.baseResourceType);
} }
function GenerateModalFolderableListItemComponent_Conditional_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "span");
    i0.ɵɵtext(2, "There are no report templates in this folder.");
    i0.ɵɵelementEnd()();
} }
function GenerateModalFolderableListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 5);
    i0.ɵɵtemplate(1, GenerateModalFolderableListItemComponent_Conditional_0_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, GenerateModalFolderableListItemComponent_Conditional_0_ng_template_3_Template, 11, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, GenerateModalFolderableListItemComponent_Conditional_0_ng_template_5_Template, 1, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, GenerateModalFolderableListItemComponent_Conditional_0_ng_template_7_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderNameFragment_r7 = i0.ɵɵreference(2);
    const folderColumnDataFragment_r8 = i0.ɵɵreference(4);
    const listItemFragment_r9 = i0.ɵɵreference(6);
    const emptyFolderFragment_r10 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r3.folderable)("ancestorInfo", ctx_r3.ancestorInfo)("folderNameFragment", folderNameFragment_r7)("folderColumnDataFragment", folderColumnDataFragment_r8)("listItemFragment", listItemFragment_r9)("emptyFolderFragment", emptyFolderFragment_r10)("maxViewDepth", 99);
} }
function GenerateModalFolderableListItemComponent_Conditional_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r3.customPDFReport));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function GenerateModalFolderableListItemComponent_Conditional_1_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("click", function GenerateModalFolderableListItemComponent_Conditional_1_div_19_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.deleteHandler($event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-delete");
} }
function GenerateModalFolderableListItemComponent_Conditional_1_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipTitle", ctx_r3.descriptionTooltip)("tooltipHtml", true)("tooltipClasses", i0.ɵɵpureFunction0(5, _c2))("tooltipPlacement", "left");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function GenerateModalFolderableListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function GenerateModalFolderableListItemComponent_Conditional_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectReport(ctx_r3.folderable.item)); });
    i0.ɵɵelementStart(1, "div", 18)(2, "div", 19)(3, "div", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 21);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵtext(6, "pdf");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "span", 23);
    i0.ɵɵelement(8, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenerateModalFolderableListItemComponent_Conditional_1_div_9_Template, 3, 6, "div", 24);
    i0.ɵɵpipe(10, "isSharedWithOthers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵelement(12, "div", 8);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 9);
    i0.ɵɵelement(15, "div", 8);
    i0.ɵɵpipe(16, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 25)(18, "div", 26);
    i0.ɵɵtemplate(19, GenerateModalFolderableListItemComponent_Conditional_1_div_19_Template, 2, 2, "div", 27)(20, GenerateModalFolderableListItemComponent_Conditional_1_div_20_Template, 2, 6, "div", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 29)(22, "label", 12);
    i0.ɵɵelement(23, "input", 13)(24, "span", 14);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r3.folderable)("ancestorInfo", ctx_r3.ancestorInfo);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("textContent", ctx_r3.customPDFReport.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 10, ctx_r3.customPDFReport));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(13, 12, ctx_r3.customPDFReport.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r3.isPdfReport ? i0.ɵɵpipeBind1(16, 15, ctx_r3.customPDFReport) : "YCharts");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.canDeleteReport(ctx_r3.customPDFReport));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.customPDFReport.report_description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(17, _c1, ctx_r3.isSelected ? "visible" : "hidden"));
} }
const GenerateReportModalFolderableAppConfig = {
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Report Templates',
};
/**
 * Component for displaying a list of reports in the generate report modal.
 */
export class GenerateModalFolderableListItemComponent extends FolderableBase {
    fileDropdownHandler(_selectedItem) { }
    get customPDFReport() {
        return this.folderable.item;
    }
    get descriptionTooltip() {
        return `<div class="pl-1 pr-1"><div class="text-bold pb-1 pt-1">Description</div><div class="text-small pb-1">${this.customPDFReport.report_description}</div></div>`;
    }
    get relativePositionedElemId() {
        const { resourceType, item } = this.folderable;
        const unique_id = isCustomPDFReport(item) ? item.id : item.report_name;
        return `list-item-delete-${resourceType}-${unique_id}`;
    }
    constructor(store, customPDFReportService, featureService, sharingService, cdr) {
        super();
        this.store = store;
        this.customPDFReportService = customPDFReportService;
        this.featureService = featureService;
        this.sharingService = sharingService;
        this.cdr = cdr;
        this.errorHandler = new EventEmitter();
        this.reportFetchSubscription = null;
        this.FolderItemType = FolderableType;
        this.isPdfReport = false;
        this.fileDropdownConfig = {};
        this.isSelected = false;
        this.securityListSelected = false;
        this.mapStateToComponent = (state) => {
            this.securityListSelected = !!state.primarySecurity.securityListGroup;
            const selectedReport = getSelectedReport(state);
            const oldSelected = this.isSelected;
            switch (this.folderable.item.report_type) {
                case LEGACY_REPORT_TYPES.TEARSHEET:
                    this.isSelected =
                        selectedReport?.tearsheet_type ===
                            this.folderable.item?.tearsheet_type;
                    break;
                case LEGACY_REPORT_TYPES.Y_RATING:
                    this.isSelected =
                        selectedReport?.report_name ===
                            this.folderable.item?.report_name;
                    break;
                default:
                    this.isSelected =
                        selectedReport?.id ===
                            this.folderable.item?.id;
            }
            if (oldSelected !== this.isSelected)
                this.cdr.detectChanges();
        };
        this.userHasEditFeature = false;
        this.userHasGenerateFeature = false;
    }
    ngOnInit() {
        this.store.select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
        this.userHasEditFeature = this.featureService.userHasFeatures([EDIT_PDF_REPORT_BUILDER_FEATURE]);
        this.userHasGenerateFeature = this.featureService.userHasFeatures([GENERATE_PDF_REPORT_FEATURE]);
        this.isPdfReport = isCustomPDFReport(this.customPDFReport);
    }
    selectReport(report) {
        if (this.isSelected) {
            this.store.dispatch(resetSelectedReport());
            return;
        }
        // Dispatch report immediately so modal appears responsive
        this.store.dispatch(setSelectedReport({ reportData: report }));
        // If the report is a legacy report, no need to fetch additional info
        if (Object.values(LEGACY_REPORT_TYPES).includes(report.report_type)) {
            // Add the export options wizard step if bulk generating a legacy report for a security list
            if (this.securityListSelected) {
                this.store.dispatch(addSelectedReportWizardStep({
                    newStep: { eventName: CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL },
                    index: 1,
                }));
            }
            return;
        }
        // Otherwise, we need to fetch generate report info for custom PDF reports
        if (this.reportFetchSubscription !== null) {
            this.reportFetchSubscription.unsubscribe();
        }
        this.reportFetchSubscription = this.customPDFReportService
            .getGenerateReportInfo(report.report_id, this.baseResourceType)
            .subscribe({
            next: (response) => {
                this.store.dispatch(setSelectedReport({ reportData: response }));
            },
            error: () => {
                this.errorHandler.emit('There was an issue selecting this report for generation.');
            },
        });
    }
    canDeleteReport(report) {
        return isCustomPDFReport(report) ? report.permissions.canDelete : false;
    }
    deleteHandler(event) {
        event.stopPropagation();
        const selectedOperation = {
            item: {
                id: this.customPDFReport.id,
                name: this.customPDFReport.name,
                itemType: this.folderable.resourceType,
                itemTypeDescription: this.folderable.resourceTypeDescription,
                ancestorFolderId: this.ancestorInfo.id,
                relativePositionedElemId: this.relativePositionedElemId,
                sharing: this.customPDFReport.sharing,
            },
            operation: 'delete',
        };
        this.store.dispatch(setGenerateModalSelectedFolderableOperation({ selectedOperation }));
    }
}
GenerateModalFolderableListItemComponent.ɵfac = function GenerateModalFolderableListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GenerateModalFolderableListItemComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.CustomPDFReportService), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i4.SharingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GenerateModalFolderableListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenerateModalFolderableListItemComponent, selectors: [["ycn-generate-modal-folderable-list-item"]], inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo", baseResourceType: "baseResourceType" }, outputs: { errorHandler: "errorHandler" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            ToastMessagesService,
            { provide: FOLDERABLE_APP_CONFIG, useValue: GenerateReportModalFolderableAppConfig },
        ]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderNameFragment", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [3, "folderable", "ancestorInfo", "folderNameFragment", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment", "maxViewDepth"], [1, "text-normal", 3, "textContent"], [1, "td", "col-3"], [1, "file-td-wrap", 3, "textContent"], [1, "td", "col-2", "col-md-2"], [1, "td", "col-1", "text-right"], [1, "file-td-control", "td"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "custom-control-indicator"], [3, "errorHandler", "folderable", "ancestorInfo", "baseResourceType"], [1, "get-started-small", "flex-auto"], ["ycn-folderable", "", 1, "tr", 3, "click", "folderable", "ancestorInfo"], [1, "td", "file-td-name"], [1, "file-name"], [1, "file-icon", "file-pdf"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], [1, "file-title"], ["class", "btn btn-xs btn-circle btn-transparent btn-share ml-1", "ycnTooltip", "", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], [1, "td", "col-1", "text-right", 2, "min-width", "50px"], [1, "d-inline-flex"], ["class", "btn btn-xs btn-circle btn-transparent2 visible-hover", "ycnTooltip", "", 3, "tooltipTitle", "click", 4, "ngIf"], ["class", "btn btn-xs btn-circle btn-transparent2 visible-hover", "ycnTooltip", "", 3, "tooltipTitle", "tooltipHtml", "tooltipClasses", "tooltipPlacement", 4, "ngIf"], [1, "td", "file-td-control"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "visible-hover", 3, "click", "tooltipTitle"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "visible-hover", 3, "tooltipTitle", "tooltipHtml", "tooltipClasses", "tooltipPlacement"]], template: function GenerateModalFolderableListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GenerateModalFolderableListItemComponent_Conditional_0_Template, 9, 7)(1, GenerateModalFolderableListItemComponent_Conditional_1_Template, 25, 19, "div", 4);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i5.NgIf, i5.NgStyle, i6.FolderableDirective, i7.FolderBaseComponent, i8.IconDirective, i9.TooltipDirective, GenerateModalFolderableListItemComponent, i5.DatePipe, i10.GetOwnerDisplayName, i11.GetSharingTooltipMessage, i12.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
